import { gql } from '@apollo/client';

export const REPORT_POST = gql`
    mutation reportPost($postId: ID!, $reason: ReportReason!, $details: String) {
        reportPost(postId: $postId, reason: $reason, details: $details) {
            id
            postId
            reporterId
            reason
            category
            details
            createdAt
            status
        }
    }
`;
